/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/account-settings';

const POLICY_LINK = `${config.url.base}about/privacy`;
const TERMS_LINK = `${config.url.base}about/terms`;

const NotificationPreferencesTOS = () => {
  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText">
      <FormattedMessage
        message={_t(
          `Coursera is committed to advancing the science of learning and teaching. Learners are important
                participants in that pursuit. The information we gather from your use of our services makes it
                possible for instructors, researchers, designers, engineers, and others to continuously improve their
                work and, in that process, advance learning and teaching. By using our services, you are also
                participating in research. Read {termsLink} and {policyLink}.`
        )}
        termsLink={
          <Link href={TERMS_LINK} target="_blank" rel="noopener" variant="standard">
            {_t('Terms of Use')}
          </Link>
        }
        policyLink={
          <Link href={POLICY_LINK} target="_blank" rel="noopener" variant="standard">
            {_t('Privacy Policy')}
          </Link>
        }
      />
    </Typography2>
  );
};

export default NotificationPreferencesTOS;
